<template>
  <div>
    <div class="box">
      <span class="top-right" @click=changeKanaMode>あ / <span>ア</span></span>
    </div>
    <div>
    <div :class="chart === 'combo-hiragana' ? 'combo-hiragana-grid' : 'hiragana-grid'">
      <div
        v-for="(char, index) in flattenedHiragana"
        :key="index"
        class="grid-item"
        :style="char === '' ? { backgroundColor: 'transparent' } : {}"
        @mouseover="hoverEventOver(index)"
        @mouseleave="hoverEventLeave(index)"
      >
        {{ char.hovered ? char.romanji : katakana ? char.katakana : char.hiragana }}
      </div>
    </div>
    </div>
  </div>
  <!-- <div>{{ chart }}</div> -->
</template>


<script>
const hiragana = {
  "base-hiragana": [
  [ { hiragana: 'あ', katakana: 'ア', romanji: "a", hovered: false }, { hiragana: 'い', katakana: 'イ', romanji: "i", hovered: false }, { hiragana: 'う', katakana: 'ウ', romanji: "u", hovered: false }, { hiragana: 'え', katakana: 'エ', romanji: "e", hovered: false }, { hiragana: 'お', katakana: 'オ', romanji: "o", hovered: false } ],
  [ { hiragana: 'か', katakana: 'カ', romanji: "ka", hovered: false }, { hiragana: 'き', katakana: 'キ', romanji: "ki", hovered: false }, { hiragana: 'く', katakana: 'ク', romanji: "ku", hovered: false }, { hiragana: 'け', katakana: 'ケ', romanji: "ke", hovered: false }, { hiragana: 'こ', katakana: 'コ', romanji: "ko", hovered: false } ],
  [ { hiragana: 'さ', katakana: 'サ', romanji: "sa", hovered: false }, { hiragana: 'し', katakana: 'シ', romanji: "shi", hovered: false }, { hiragana: 'す', katakana: 'ス', romanji: "su", hovered: false }, { hiragana: 'せ', katakana: 'セ', romanji: "se", hovered: false }, { hiragana: 'そ', katakana: 'ソ', romanji: "so", hovered: false } ],
  [ { hiragana: 'た', katakana: 'タ', romanji: "ta", hovered: false }, { hiragana: 'ち', katakana: 'チ', romanji: "chi", hovered: false }, { hiragana: 'つ', katakana: 'ツ', romanji: "tsu", hovered: false }, { hiragana: 'て', katakana: 'テ', romanji: "te", hovered: false }, { hiragana: 'と', katakana: 'ト', romanji: "to", hovered: false } ],
  [ { hiragana: 'な', katakana: 'ナ', romanji: "na", hovered: false }, { hiragana: 'に', katakana: '二', romanji: "ni", hovered: false }, { hiragana: 'ぬ', katakana: 'ヌ', romanji: "nu", hovered: false }, { hiragana: 'ね', katakana: 'ネ', romanji: "ne", hovered: false }, { hiragana: 'の', katakana: 'ノ', romanji: "no", hovered: false } ],
  [ { hiragana: 'は', katakana: 'ハ', romanji: "ha", hovered: false }, { hiragana: 'ひ', katakana: 'ヒ', romanji: "hi", hovered: false }, { hiragana: 'ふ', katakana: 'フ', romanji: "fu", hovered: false }, { hiragana: 'へ', katakana: 'ヘ', romanji: "he", hovered: false }, { hiragana: 'ほ', katakana: 'ホ', romanji: "ho", hovered: false } ],
  [ { hiragana: 'ま', katakana: 'マ', romanji: "ma", hovered: false }, { hiragana: 'み', katakana: 'ミ', romanji: "mi", hovered: false }, { hiragana: 'む', katakana: 'ム', romanji: "mu", hovered: false }, { hiragana: 'め', katakana: 'メ', romanji: "me", hovered: false }, { hiragana: 'も', katakana: 'モ', romanji: "mo", hovered: false } ],
  [ { hiragana: 'や', katakana: 'ヤ', romanji: "ya", hovered: false }, '',                                                                { hiragana: 'ゆ', katakana: 'ユ', romanji: "yu", hovered: false }, '',                                                               { hiragana: 'よ', katakana: 'ヨ', romanji: "yo", hovered: false } ],
  [ { hiragana: 'ら', katakana: 'ラ', romanji: "ra", hovered: false }, { hiragana: 'り', katakana: 'リ', romanji: "ri", hovered: false }, { hiragana: 'る', katakana: 'ル', romanji: "ru", hovered: false }, { hiragana: 'れ', katakana: 'レ', romanji: "re", hovered: false }, { hiragana: 'ろ', katakana: 'ロ', romanji: "ro", hovered: false } ],
  [ { hiragana: 'わ', katakana: 'ワ', romanji: "wa", hovered: false }, '',                                                                '',                                                               '',                                                                { hiragana: 'を', katakana: 'ヲ', romanji: "wo", hovered: false }  ]
],
  "dakuten-hiragana": [
  [ { hiragana: 'が', katakana: 'ガ', romanji: "ga", hovered: false }, { hiragana: 'ぎ', katakana: 'ギ', romanji: "gi", hovered: false }, { hiragana: 'ぐ', katakana: 'グ', romanji: "gu", hovered: false }, { hiragana: 'げ', katakana: 'ゲ', romanji: "ge", hovered: false }, { hiragana: 'ご', katakana: 'ゴ', romanji: "go", hovered: false } ],
  [ { hiragana: 'ざ', katakana: 'ザ', romanji: "za", hovered: false }, { hiragana: 'じ', katakana: 'ジ', romanji: "ji", hovered: false }, { hiragana: 'ず', katakana: 'ズ', romanji: "zu", hovered: false }, { hiragana: 'ぜ', katakana: 'ゼ', romanji: "ze", hovered: false }, { hiragana: 'ぞ', katakana: 'ゾ', romanji: "zo", hovered: false } ],
  [ { hiragana: 'だ', katakana: 'ダ', romanji: "da", hovered: false }, '', { hiragana: 'づ', katakana: 'ヅ', romanji: "dzu", hovered: false }, { hiragana: 'で', katakana: 'デ', romanji: "de", hovered: false }, { hiragana: 'ど', katakana: 'ド', romanji: "do", hovered: false } ],
  [ { hiragana: 'ば', katakana: 'バ', romanji: "ba", hovered: false }, { hiragana: 'び', katakana: 'ビ', romanji: "bi", hovered: false }, { hiragana: 'ぶ', katakana: 'ブ', romanji: "bu", hovered: false }, { hiragana: 'べ', katakana: 'ベ', romanji: "be", hovered: false }, { hiragana: 'ぼ', katakana: 'ボ', romanji: "bo", hovered: false } ],
  [ { hiragana: 'ぱ', katakana: 'パ', romanji: "pa", hovered: false }, { hiragana: 'ぴ', katakana: 'ピ', romanji: "pi", hovered: false }, { hiragana: 'ぷ', katakana: 'プ', romanji: "pu", hovered: false }, { hiragana: 'ぺ', katakana: 'ペ', romanji: "pe", hovered: false }, { hiragana: 'ぽ', katakana: 'ポ', romanji: "po", hovered: false } ]
],
"combo-hiragana": [
  [ { hiragana: 'きゃ', katakana: 'キャ', romanji: "kya", hovered: false }, { hiragana: 'きゅ', katakana: 'キュ', romanji: "kyu", hovered: false }, { hiragana: 'きょ', katakana: 'キョ', romanji: "kyo", hovered: false } ],
  [ { hiragana: 'ぎゃ', katakana: 'ギャ', romanji: "gya", hovered: false }, { hiragana: 'ぎゅ', katakana: 'ギュ', romanji: "gyu", hovered: false }, { hiragana: 'ぎょ', katakana: 'ギョ', romanji: "gyo", hovered: false } ],
  [ { hiragana: 'しゃ', katakana: 'シャ', romanji: "sha", hovered: false }, { hiragana: 'しゅ', katakana: 'シュ', romanji: "shu", hovered: false }, { hiragana: 'しょ', katakana: 'ショ', romanji: "sho", hovered: false } ],
  [ { hiragana: 'じゃ', katakana: 'ジャ', romanji: "jya", hovered: false }, { hiragana: 'じゅ', katakana: 'ジュ', romanji: "jyu", hovered: false }, { hiragana: 'じょ', katakana: 'ジョ', romanji: "jyo", hovered: false } ],
  [ { hiragana: 'ちゃ', katakana: 'チャ', romanji: "cha", hovered: false }, { hiragana: 'ちゅ', katakana: 'チュ', romanji: "chu", hovered: false }, { hiragana: 'ちょ', katakana: 'チョ', romanji: "cho", hovered: false } ],
  [ { hiragana: 'にゃ', katakana: 'ニャ', romanji: "nya", hovered: false }, { hiragana: 'にゅ', katakana: 'ニュ', romanji: "nyu", hovered: false }, { hiragana: 'にょ', katakana: 'ニョ', romanji: "nyo", hovered: false } ],
  [ { hiragana: 'りゃ', katakana: 'リャ', romanji: "rya", hovered: false }, { hiragana: 'りゅ', katakana: 'リュ', romanji: "ryu", hovered: false }, { hiragana: 'りょ', katakana: 'リョ', romanji: "ryo", hovered: false } ],
  [ { hiragana: 'みゃ', katakana: 'ミャ', romanji: "mya", hovered: false }, { hiragana: 'みゅ', katakana: 'ミュ', romanji: "myu", hovered: false }, { hiragana: 'みょ', katakana: 'ミョ', romanji: "myo", hovered: false } ],
  [ { hiragana: 'ひゃ', katakana: 'ヒャ', romanji: "hya", hovered: false }, { hiragana: 'ひゅ', katakana: 'ヒュ', romanji: "hyu", hovered: false }, { hiragana: 'ひょ', katakana: 'ヒョ', romanji: "hyo", hovered: false } ],
  [ { hiragana: 'びゃ', katakana: 'ビャ', romanji: "bya", hovered: false }, { hiragana: 'びゅ', katakana: 'ビュ', romanji: "byu", hovered: false }, { hiragana: 'びょ', katakana: 'ビョ', romanji: "byo", hovered: false } ],
  [ { hiragana: 'ぴゃ', katakana: 'ピャ', romanji: "pya", hovered: false }, { hiragana: 'ぴゅ', katakana: 'ピュ', romanji: "pyu", hovered: false }, { hiragana: 'ぴょ', katakana: 'ピョ', romanji: "pyo", hovered: false } ]
]



}
    export default {
        name: 'WritingSystemChart',
        props: {
          chart: String 
        },
        data(){
            return {
                flattenedHiragana:  hiragana[this.chart].flat(),
                katakana: false
            }        
        },
        methods: {
            changeKanaMode() {
              this.katakana = !this.katakana;
            },
            hoverEventOver(index) {
                if (this.flattenedHiragana[index] != '') {
                  this.flattenedHiragana[index].hovered = true;
                }
            },  
            hoverEventLeave(index) {
                if (this.flattenedHiragana[index] != '') {
                  this.flattenedHiragana[index].hovered = false;
                }
            }
        }
    }
</script>

<style scoped>

.box {
  position: relative;
  margin-bottom:50px;
  /* background: #f2f2f2;
  border: 1px solid #ccc; */
  padding: 10px;
}

.top-right {
  position: absolute;
  cursor: pointer;
  top: 10px;
  right: 10px;
  /* color:  #F0EAD6; */
  color: black;
}

.hiragana-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 columns to match rows */
  gap: 12px;
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
}

.combo-hiragana-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns to match rows */
  gap: 12px;
  max-width: 400px;
  margin: 0 auto;
  text-align: center;
}

.grid-item {
  padding: 12px;
  font-size: 24px;
  background-color: #f1f1f1;
  border-radius: 8px;
  min-height: 40px;
}
</style>
